import React from 'react';
import * as S from './styles';

export function AddressView() {
  return (
    <S.Wrapper>
      <S.Office>
        <S.OfficeInner right>
          <S.Heading>Satyawati LLC</S.Heading>
          <S.OfficeLabel>US Office</S.OfficeLabel>

          <S.InfoRow alignRight>
            <S.AddressIcon />
            <S.Address>
              8005 Linda Michelle Ln
              <br />
              Austin, TX 78724
            </S.Address>
          </S.InfoRow>

          <S.InfoRow alignRight>
            <S.PhoneIcon />
            <S.Phone href="tel:+15127665597">+1-(512)-766-5597</S.Phone>
          </S.InfoRow>
        </S.OfficeInner>
      </S.Office>

      <S.Office>
        <S.OfficeInner>
          <S.Heading>
            Satyawati Technologies
            <br />
            Pvt. Ltd.
          </S.Heading>
          <S.OfficeLabel>Nepal Office</S.OfficeLabel>

          <S.InfoRow>
            <S.AddressIcon />
            <S.Address>
              Tilottama 6, Manigram
              <br />
              Rupandehi
              <br />
              Lumbini Province
            </S.Address>
          </S.InfoRow>

          <S.InfoRow>
            <S.PhoneIcon />
            <S.Phone href="tel:+9779826466033">+977-(982)-646-6033</S.Phone>
          </S.InfoRow>
        </S.OfficeInner>
      </S.Office>
    </S.Wrapper>
  );
}
